module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-groups"
  }, [_c('div', {
    staticClass: "cart-header"
  }, [_c('div', {
    staticClass: "cart-item1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_product')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item2"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_price')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_Quantity')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item5"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('order_amount_paid')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item4"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_order_status')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item6"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_operation')))])])]), _vm._v(" "), _vm._l((_vm.orderList), function(order, index) {
    return _c('div', {
      staticClass: "order-list"
    }, [_c('div', {
      staticClass: "pc-order-list"
    }, [_c('div', {
      staticClass: "order-row-header"
    }, [_vm._v("\n                " + _vm._s(_vm.$t('user_center_order_order_num')) + "：\n                "), _c('router-link', {
      attrs: {
        "to": {
          name: 'MyDetails',
          params: {
            order_sn: order.order_sn
          }
        }
      }
    }, [_vm._v(_vm._s(order.order_sn) + "\n                ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "order-row"
    }, [_c('div', {
      staticClass: "order-row-goods"
    }, _vm._l((order.order_detail), function(item, i) {
      return _c('div', {
        staticClass: "goods-list"
      }, [_c('div', {
        staticClass: "goods-header goods-item"
      }, [_c('img', {
        attrs: {
          "src": item.goods_img
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "goods-desc-group"
      }, [_c('div', {
        staticClass: "goods-desc goods-item"
      }, [_c('h3', [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "max-width": "200px",
          "font-size": "16px"
        }
      }, [_vm._v("\n                                    " + _vm._s(item.product_introduction) + "\n                                ")])]), _vm._v(" "), _c('div', {
        staticClass: "goods-price goods-item"
      }, [_vm._v(_vm._s(item.goods_unit) + " " + _vm._s(item.goods_price))]), _vm._v(" "), _c('div', {
        staticClass: "goods-num goods-item"
      }, [_c('span', [_vm._v(_vm._s(item.goods_num))])])]), _vm._v(" "), _c('div', {
        staticClass: "order-status-operation"
      }, [_c('div', {
        staticClass: "order-status"
      }, [(i == 0) ? _c('div', {
        staticClass: "goods-price goods-item"
      }, [_c('span', {
        staticStyle: {
          "color": "#0084ff"
        }
      }, [_vm._v(_vm._s(item.goods_unit) + " " + _vm._s(order.need_pay_usd_price))]), _c('div', {
        staticStyle: {
          "font-size": "16px"
        }
      }, [_vm._v("(" + _vm._s(_vm.$t('order_freight')) + ":" + _vm._s(order.shipping_price) + ")")])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "order-status"
      }, [(i == 0) ? _c('p', {
        staticClass: "goods-item"
      }, [_vm._v(_vm._s(_vm.filterStatus(order.order_status)))]) : _vm._e(), _vm._v(" "), (i == 0) ? _c('p', [_c('router-link', {
        attrs: {
          "to": {
            name: 'MyDetails',
            params: {
              order_sn: order.order_sn
            }
          }
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.$t('user_center_order_order_details')) + "\n                                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "order-operation goods-item"
      }, [(order.order_status == 0) ? _c('div', {
        staticClass: "operation-group"
      }, [(i == 0) ? _c('p', [_c('a', {
        staticClass: "btn btn-primary operation-pay",
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            _vm.checkOut(order.order_sn)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('payment_btn')))])]) : _vm._e(), _vm._v(" "), (i == 0) ? _c('p', [_c('a', {
        on: {
          "click": function($event) {
            _vm.openCancelModel(order.order_sn)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('user_center_order_cancel_order')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (order.order_status == 2 || order.order_status == 3 || order.order_status == 1) ? _c('div', {
        staticClass: "goods-item"
      }, [(i == 0) ? _c('p', {
        staticClass: "goods-item"
      }, [_c('a', {
        staticStyle: {
          "color": "#0084ff"
        },
        on: {
          "click": function($event) {
            _vm.confirmOrder(order.order_sn)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('user_order_confirm')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (order.order_status == 4) ? _c('div', {
        staticClass: "goods-item"
      }, [(i == 0) ? _c('div', [(order.end_status === true) ? _c('p', {
        staticClass: "goods-item"
      }, [_c('router-link', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "to": {
            name: 'MyDetails',
            params: {
              order_sn: order.order_sn
            }
          }
        }
      }, [_vm._v("\n                                                " + _vm._s(_vm.$t('user_center_order_return_exchange')) + "\n                                            ")])], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])])])
    }))])]), _vm._v(" "), _c('div', {
      staticClass: "mobile-order-list"
    }, [_c('div', {
      staticClass: "order-row-header"
    }, [_vm._v("\n                " + _vm._s(_vm.$t('user_center_order_order_num')) + "：\n                "), _c('router-link', {
      attrs: {
        "to": {
          name: 'MyDetails',
          params: {
            order_sn: order.order_sn
          }
        }
      }
    }, [_vm._v(_vm._s(order.order_sn) + "\n                ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "background": "#F9FCFF",
        "width": "100%",
        "padding": "5px"
      }
    }, _vm._l((order.order_detail), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "order-row"
      }, [_c('div', {
        staticClass: "goods-header"
      }, [_c('img', {
        attrs: {
          "src": item.goods_img
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "goods-desc"
      }, [_c('h3', [_vm._v("\n                            " + _vm._s(item.goods_name) + "\n                        ")]), _vm._v(" "), _c('p', [_vm._v("$" + _vm._s(item.goods_price) + "  x  " + _vm._s(item.goods_num))]), _vm._v(" "), _c('div', {
        staticClass: "goods-status"
      }, [_c('span', [_vm._v(_vm._s(_vm.filterStatus(order.order_status)))]), _vm._v(" "), _c('span', [_c('router-link', {
        attrs: {
          "to": {
            name: 'MyDetails',
            params: {
              order_sn: order.order_sn
            }
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.$t('user_center_order_order_details')) + "\n                                ")])], 1)]), _vm._v(" "), _c('div', {
        staticClass: "goods-operation"
      }, [(order.order_status == 0) ? _c('div', {
        staticClass: "operation-group"
      }, [_c('p', [_c('a', {
        staticClass: "btn btn-primary operation-pay",
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            _vm.checkOut(order.order_sn)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('payment_btn')))])]), _vm._v(" "), _c('p', [_c('a', {
        on: {
          "click": function($event) {
            _vm.openCancelModel(order.order_sn)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('user_center_order_cancel_order')))])])]) : _vm._e(), _vm._v(" "), (order.order_status == 2 || order.order_status == 3 || order.order_status == 1) ? _c('div', {}, [_c('p', [_c('a', {
        on: {
          "click": function($event) {
            _vm.confirmOrder(order.order_sn)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('user_order_confirm')))])])]) : _vm._e(), _vm._v(" "), (order.order_status == 4) ? _c('div', {}, [_c('p', [_c('router-link', {
        attrs: {
          "to": {
            name: 'MyDetails',
            params: {
              order_sn: order.order_sn
            }
          }
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.$t('user_center_order_return_exchange')) + "\n                                    ")])], 1)]) : _vm._e()])])])
    }))])])
  }), _vm._v(" "), _c('modal', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.$t('user_center_order_cancel_order')
    },
    on: {
      "on-ok": _vm.cancelOrder
    },
    model: {
      value: (_vm.showCancel),
      callback: function($$v) {
        _vm.showCancel = $$v
      },
      expression: "showCancel"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('user_center_order_cancel_order_tip')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelOrderNumber),
      expression: "cancelOrderNumber"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.cancelOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cancelOrderNumber = $event.target.value
      }
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dba868e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Common/Orders.vue
// module id = 825
// module chunks = 0